import * as React from "react";
import {DocumentManager} from "app/PDFImporter/Manager/PDFManager/DocumentManager";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {PDFPreview} from "../../PDFPreview/PDFPreview";
import {FieldSettings} from "../../Controls/FieldSettings/FieldSettings";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {AddField} from "../../Controls/AddField/AddField";
import {TextFieldSettings} from "../../Controls/FieldSettings/TextFieldSettings";

export class DesignerTab extends React.Component<DesignerTabProps, DesignerTabState> {
    static defaultProps: Partial<DesignerTabProps> = {};

    constructor(props: DesignerTabProps) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.props.DocumentManager.SelectedPDFFieldChanged.Subscribe(this,()=>this.forceUpdate());
        this.props.DocumentManager.RefreshDesignerTab.Subscribe(this,()=>this.forceUpdate());
    }

    componentWillUnmount() {
        this.props.DocumentManager.RefreshDesignerTab.Unsubscribe(this);
        this.props.DocumentManager.SelectedPDFFieldChanged.Unsubscribe(this);
    }


    public render() {
        return (
            <div style={{width:'100%',height:'100%',display:'flex',backgroundColor:'rgb(239, 239, 239)'}}>
                <div style={{width:500,height:'100%',minWidth:400}}>
                    <Tabs TabToOpen={this.props.DocumentManager.SelectedTab} TabToOpenChanged={x=>{this.props.DocumentManager.SelectedTab=x;this.forceUpdate()}} OccupyAvailableSpace={true} styles={{height:'calc(100% - 5px)',border:"none",marginTop:5}} >
                        <Tabs.Item Title={'Field Settings'} Id={'Fields'} Icon={<FontAwesomeIcon icon={faCog}/>} style={{padding:0}}>
                            <div style={{width:'100%',height:'100%',overflowY:'auto'}}>
                                {this.GetFieldSettings()}
                            </div>
                        </Tabs.Item>
                        <Tabs.Item Title={'Add Field'} Id={'AddField'} Icon={<FontAwesomeIcon icon={faPlus}/>} style={{padding:0}}>
                                <AddField DocumentManager={this.props.DocumentManager}/>
                        </Tabs.Item>

                    </Tabs>
                </div>
                <div style={{flexGrow:1,backgroundColor:'rgb(223, 223, 223)',borderLeft:'1px solid #999',overflow:"auto"}}>
                    <PDFPreview SelectedAnnotation={null} DocumentManager={this.props.DocumentManager}/>
                </div>
            </div>
        )
    }


    public GetFieldSettings(){
        switch (this.props.DocumentManager?.SelectedPDFField?.AnotationObject?.fieldType)
        {
            case 'Tx':
                return <TextFieldSettings DocumentManager={this.props.DocumentManager} />
            default:
                return <FieldSettings DocumentManager={this.props.DocumentManager} />

        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface DesignerTabProps {
    DocumentManager:DocumentManager;

}

interface DesignerTabState {

}

//#endregion "My Region"